import React from 'react';

const EnergyCertificateGradeE = props => (
  <svg width="200" height="34" viewBox="0 0 200 34" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0 0.628078V33.1073H182.858L199.226 16.7401L182.858 0.628078H0Z" fill="#F29020" />
    <path
      d="M173.661 8.86886H160.414V14.1164H172.582V18.5307H160.414V24.9983H174.25V29.4125H155.306V4.45271H173.661V8.86886Z"
      fill="white"
    />
  </svg>
);

export default EnergyCertificateGradeE;
